import {useState} from 'react';
import type {FC} from 'react';
import {useNavigate} from 'react-router-dom';
import {
  Button,
  Icon,
  IconNames,
  Menu,
  MenuItem,
  Typography,
} from '@wellstone-solutions/web';
import {Theme} from '@wellstone-solutions/common';

interface ActionButtonType {
  group: number;
}

export const ActionButton: FC<ActionButtonType> = ({group}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const navigate = useNavigate();

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        sx={{width: 40, height: 40, padding: 0}}
        onClick={handleClick}
        data-testid={'group-detail-actions'}>
        <Icon
          name={IconNames.MoreVert}
          color={Theme.colorPalette.darkest}
          style={styles.iconMenu}
        />
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        transformOrigin={{horizontal: 'right', vertical: 'top'}}
        anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}>
        <MenuItem
          onClick={() => {
            navigate(`/groups/${group}`);
          }}>
          <Icon name={IconNames.Eye} style={styles.iconItem} />
          <Typography sx={styles.option}>View Group</Typography>
        </MenuItem>

        <MenuItem
          onClick={() => {
            navigate(`/groups/${group}/edit`);
          }}>
          <Icon name={IconNames.EditPencil} style={styles.iconItem} />
          <Typography sx={styles.option}>Edit series</Typography>
        </MenuItem>
      </Menu>
    </>
  );
};

const styles = {
  bold: {
    fontWeight: 'bold',
  },
  iconMenu: {strokeWidth: '3px'},
  iconItem: {strokeWidth: '2px', color: Theme.colorPalette.dark},
  option: {
    paddingLeft: 1,
  },
};
